import { render, staticRenderFns } from "./ComplianceEventDetails.vue?vue&type=template&id=50f19ac3&"
import script from "./ComplianceEventDetails.vue?vue&type=script&lang=js&"
export * from "./ComplianceEventDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports